import { Injectable } from '@angular/core';
import { GatewayService } from 'src/app/gateway.service';

@Injectable({
  providedIn: 'root'
})
export class CpQrCodeService {

  constructor(private readonly gatewayApis: GatewayService) { }

  public downloadDataViaDMS(fileIds) {
    const body =
    {
      'DMS_DOWNLOAD_FILE': [
        {
          fileReturnType: 'URL',
          idList: [fileIds],
          expiryTime: 500000
        }
      ]
    }
    return this.gatewayApis.callApiClientURLDownloadDms(body);
  }

  public sendQrEmail(cpUserId, linkArray) {
    const body = {
      'SPSENDCPQREMAIL': [
        {
          x_mobile_no: cpUserId,
          x_filter_property: linkArray,
        }
      ]
    }
    return this.gatewayApis.callApiClientURLDownloadDms(body);
  }
}
